import { render, staticRenderFns } from "./OrderDetails.vue?vue&type=template&id=03bc8e68&scoped=true&"
import script from "./OrderDetails.vue?vue&type=script&lang=js&"
export * from "./OrderDetails.vue?vue&type=script&lang=js&"
import style0 from "lity/dist/lity.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./OrderDetails.vue?vue&type=style&index=1&id=03bc8e68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03bc8e68",
  null
  
)

export default component.exports